/** A field's identity: the (client, farm, field) name triple. */
export type Cff = { client: string; farm: string; field: string }

/**
 * Planning names and stream-derived names come from different datastores and can
 * carry incidental surrounding whitespace, so both sides are trimmed before the
 * two are held to name the same field.
 */
export const cffKey = (cff: Cff): string =>
  `${cff.client.trim()}|${cff.farm.trim()}|${cff.field.trim()}`

export const sameCff = (a: Cff, b: Cff): boolean => cffKey(a) === cffKey(b)

const names = ({ client, farm, field }: Cff): Cff => ({ client, farm, field })

export const uniqueCffs = (fields: readonly Cff[]): Cff[] => [
  ...new Map(fields.map((field) => [cffKey(field), names(field)])).values()
]

export const unregisteredCffs = ({
  fields,
  planningFields
}: {
  fields: readonly Cff[]
  planningFields: readonly Cff[]
}): Cff[] => {
  const registered = new Set(planningFields.map(cffKey))
  return uniqueCffs(fields.filter((field) => !registered.has(cffKey(field))))
}
